import { defineStore } from 'pinia';
import i18n from '@/locale';
import Storage from '@/utils/storage';
const vtoken = import.meta.env.VITE_TOKEN;
const vuser = import.meta.env.VITE_USER;
const vcontact = 'dcontact';
const vDeanUser = 'dDeanUser';

export const useAuthStore = defineStore('AuthStore', {
	state: () => ({
		lang: Storage.get('lang', i18n.defaultLocale),
		token: Storage.get(vtoken, ''),
		user: Storage.get(vuser, {}),
		contact: Storage.get(vcontact, {}),
		deanUser: Storage.get(vDeanUser, {}),
	}),
	actions: {
		setLang(data) {
			this.lang = data;
			Storage.set('lang', data); // local storage
			i18n.locale = data;
		},
		setUser(data) {
			// update pinia state token
			this.token = data.token;
			Storage.set(vtoken, this.token); // local storage
			delete data.token;

			// update pinia state user
			this.user = data.school || {};
			Storage.set(vuser, this.user); // local storage

			// update pinia state user
			this.contact = data.school_contact || {};
			Storage.set(vcontact, this.contact); // local storage
		},
		setUserContact(data) {
			this.contact = {
				...this.contact,
				...data,
			};
			Storage.set(vcontact, this.contact);
		},
		setDeanUser(data) {
			this.deanUser = {
				...this.deanUser,
				...data,
			};
			Storage.set(vDeanUser, this.deanUser);
		},
		logout(path = '/') {
			Storage.removeAll();
			this.token = null;
			this.user = {};
			setTimeout(() => {
				window.location.href = import.meta.env.VITE_BASE_URL || '/' + path;
			}, 120);
		},
	},
});
